import {AnyAction} from 'redux'
import {DatesState} from '../types/state'
import {UPDATE_DATES} from '../actions/dates'

export const dates = (state: DatesState = {} as DatesState, action: AnyAction) => {
  switch (action.type) {
    case UPDATE_DATES:
      return {
        ...state,
        events: {
          ...state.events,
          ...action.payload.events,
        },
        common: {
          ...state.common,
          ...action.payload.common,
        },
      }
    default:
      return state
  }
}
